export const getMetricFrequencyKey = (id?: string) =>
  `${id}-metricCellFrequencyKey`;
